<template>
  <div class="recipe_add">
    <br />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>
      <el-breadcrumb-item>已完成</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="已完成" name="first">
        <el-container>
          <!-- <el-header>空置区域  </el-header> -->
          <el-main>
            <el-form ref="form" :model="form" label-width="100px">
              <table width="100%">
                <tr>
                  <td style="width:300px">
                    <el-form-item label="开始时间" prop="startTime">
                      <el-date-picker
                        v-model="form.startTime"
                        format="yyyy-MM-dd "
                        value-format="yyyy-MM-dd "
                        clearable
                        style="width:200px"
                        :picker-options="startDatePicker"
                        type="date"
                        placeholder="请输入查询开始时间"
                      ></el-date-picker>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="结束时间" prop="endTime">
                      <el-date-picker
                        v-model="form.endTime"
                        format="yyyy-MM-dd "
                        value-format="yyyy-MM-dd "
                        clearable
                        style="width: 200px"
                        :picker-options="endDatePicker"
                        type="date"
                        placeholder="请输入查询结束时间"
                      ></el-date-picker>
                    </el-form-item>
                  </td>
                </tr>
                <tr></tr>
              </table>
            </el-form>
            <el-form label-width="30px">
              <el-form-item>
                <el-button type="primary" @click="onSubmit()">查询</el-button>
              </el-form-item>
            </el-form>
            <div class="form-region-header font-30">
              <!-- 表格上方标题文字占位 -->
            </div>
            <table width="100%">
              <tr>
                <td>
                  <el-table
                    :data="successTableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                    style="width: 100%"
                  >
                    <el-table-column prop="date" label="审核通过时间" width="180"></el-table-column>
                    <el-table-column prop="username" label="客户" width="180"></el-table-column>
                    <el-table-column prop="status" label="当前状态"></el-table-column>
                    <el-table-column prop="operation" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          v-show="scope.row.active === true"
                          :disabled="!scope.row.active === true"
                          type="primary"
                          icon="el-icon-search"
                          @click="onCheckSuccess(scope.row.pspDetailID)"
                        >查看处方</el-button>
                      </template>
                    </el-table-column>

                    <el-table-column prop="deactivateCase" label="特殊操作">
                      <template slot-scope="scope">
                        <el-button
                          v-show="scope.row.active === true"
                          icon="el-icon-delete" 
                          :disabled="!scope.row.active === true"
                          @click="onCheckDeactivate(scope.row.pspDetailID)"
                        >废弃处方</el-button>
                      </template>
                    </el-table-column>

                  </el-table>
                </td>
              </tr>
            </table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next,jumper"
              :total="currentTotal"
            ></el-pagination>
          </el-main>
        </el-container>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Success",
  data() {
    return {
      activeName: "first",
      offsetDays: 20, //默认多少天前的数据开始显示

      currentPage: 1,
      pageSize: 30,
      currentTotal: 0,

      formBinds: {},
      successAPIbyDate: "https://yc.suyizaixian.com:30005/approvedCasesByDateRange",
      disableCaseAPI:"https://yc.suyizaixian.com:30005/disableCase",
      successTableData: [],
      rules: {},
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      form: {
        startTime: "",
        endTime: ""
      }

      // 时间选取控件相关数据
      /*
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      } */
    };
  },
  props: {
    msg: String
  },
  methods: {
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endTime).getTime() < time.getTime();
          } else {
            var timeNow = Date.now();
            return time.getTime() > timeNow;
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            var timeNow = Date.now();
            return (
              time.getTime() < new Date(self.form.startTime).getTime() ||
              time.getTime() > timeNow
            );
          } else {
            return time.getTime() > timeNow;
          }
        }
      };
    },
    onCheckSuccess(PrintRecipeID) {
      // const {href} = this.$router.resolve({
      // name: "/RecipePrint"});
      // window.open(href, '_blank');
      //console.log(PrintRecipeID);
      sessionStorage.setItem("PrintRecipeID", PrintRecipeID);
      let routeData = this.$router.resolve({
          path: "/RecipePrint",
        query: {}
        });

      window.open(routeData.href, "_blank");       
    },

    onCheckDeactivate(recipeID){

      let params = {
      authToken: sessionStorage.getItem("authToken"),
      recipeID:recipeID
    };

      this.$confirm("处方废弃后将无法再次显示，是否确定废弃?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {

      this.axios
              .post(this.disableCaseAPI, qs.stringify(params))
              .then(function(res){
                if (res.data.data.result === "fail") {
                    alert("处方废弃失败，请稍后重试");
                  } else {
                    alert("处方已废弃");
                    location.reload();
              }}).catch((e) => { alert(e+"，出错，请重新登录重试");});
          })
          .catch(() => {});

    },

    toJSONLocalDate(date) {
      var local = new Date(date);
      local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return local
        .toJSON()
        .slice(0, 16)
        .replace("T", " ");
    },

    onSubmit() {

      var __this = this;
      let start = new Date(__this.form.startTime);
      start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate());
      let end = new Date(__this.form.endTime);
      end.setHours(23, 59, 59, 999);
      //TODO comment the hard code/
      let params = {
        startDate: __this.toJSONLocalDate(start),
        endDate: __this.toJSONLocalDate(end),
        authToken: sessionStorage.getItem("authToken")
      };
      __this.successTableData=[];
      const promise1 = this.axios.post(__this.successAPIbyDate, qs.stringify(params));
      Promise.all([promise1]).then(function(results) {
        for (let result of results) {
          if (result.data.data.result === "success") {
            //console.log(result.data.data.result);
            //console.log(result.data.data);
            if (result.data.data.CasesList !== undefined) {
              __this.currentTotal = result.data.data.CasesList.length;
              for (let caseItem of result.data.data.CasesList) {
                __this.successTableData.push({
                  pspDetailID: caseItem.recipeID,
                  date: __this.toJSONLocalDate(new Date(caseItem.approvedTime)),
                  username: caseItem.customerName,
                  status: "处方申请完成",
                  active: caseItem.pspStatus === 6 ? true : false
                });
              }
            }
          }
        }
        //console.log(__this.auditTableData);
      }).catch((e) => { alert(e+"，登录超时，请重新登录");});
    },
    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val;
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      //console.log(`当前页: ${val}`);
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var __this = this;
    let start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - __this.offsetDays);
    let end = new Date();
    end.setHours(23, 59, 59, 999);
    //TODO comment the hard code/
    let params = {
      startDate: __this.toJSONLocalDate(start),
      endDate: __this.toJSONLocalDate(end),
      authToken: sessionStorage.getItem("authToken")
    };
    __this.form.startTime = new Date(start);
    __this.form.endTime = new Date(end);

    const promise1 = this.axios.post(__this.successAPIbyDate, qs.stringify(params));
    Promise.all([promise1]).then(function(results) {
      for (let result of results) {
        if (result.data.data.result === "success") {
          //console.log(result.data.data.result);
          //console.log(result.data.data);
          if (result.data.data.CasesList !== undefined) {
            __this.currentTotal = result.data.data.CasesList.length;
            for (let caseItem of result.data.data.CasesList) {
              __this.successTableData.push({
                pspDetailID: caseItem.recipeID,
                date: __this.toJSONLocalDate(new Date(caseItem.approvedTime)),
                username: caseItem.customerName,
                status: "处方申请完成",
                active: caseItem.pspStatus === 6 ? true : false
              });
            }
          }
        }
      }
      //console.log(__this.auditTableData);
    }).catch((e) => { alert(e+"，登录超时，请重新登录");});
    /*
    this.axios.get(this.successAPI).then(function(response) {
      if (response.data.data.result === "success") {
        let arrCompleted = response.data.data.submittedList;
        __this.currentTotal = arrCompleted.length;
        for (let completedItem of arrCompleted) {
          __this.successTableData.push({
            date: __this.toJSONLocalDate(new Date(completedItem.submitTime)),
            username: completedItem.customerName,
            status: "处方申请完成",
            pspDetailID: completedItem.recipeID,
            active: true
          });
        }
      }
    });
    */
  }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
